import chat from "../../ui/art/touch/chat.png";
import attack from "../../ui/art/touch/attack.png";
import enter from "../../ui/art/touch/enter.png";
import harvest from "../../ui/art/touch/harvest.png";
import jump from "../../ui/art/touch/jump.png";
import pickup from "../../ui/art/touch/pickup.png";
import read from "../../ui/art/touch/read.png";
import sprint from "../../ui/art/touch/sprint.png";
import stanceDrawn from "../../ui/art/touch/stance-drawn.png";
import stanceSheathed from "../../ui/art/touch/stance-sheathed.png";
import swap from "../../ui/art/touch/swap.png";
import steal from "../../ui/art/touch/steal.png";
import talk from "../../ui/art/touch/talk.png";
import tool from "../../ui/art/touch/tool.png";
import use from "../../ui/art/touch/use.png";

/**
 * The touch buttons' icons (ADR-061's amendment of 2026-10-31): original 32 by 32 colour art under `ui/art/touch/`, one
 * for each thing a button can show. `steal` is drawn for later and no button shows it yet; `chat` is the Chat button's, in the top row beside the Bag button.
 */
export const TOUCH_ICONS = { attack, chat, enter, harvest, jump, pickup, read, sprint, stanceDrawn, stanceSheathed, steal, swap, talk, tool, use } as const;

/**
 * An icon's name.
 */
export type TouchIconName = keyof typeof TOUCH_ICONS;

/**
 * The icon's size in logical pixels: one icon pixel is one logical pixel.
 */
export const TOUCH_ICON_SIZE = 32;
